import type { User } from "@/services/api/user";
import { humanizeEnumValue } from "@/lib/utils";

export const formatMemberSubtitle = (user: User): string => {
  const company = user.companyName?.trim();
  const persona = user.userType ? humanizeEnumValue(user.userType) : null;
  if (company && persona) {
    return `${company} · ${persona}`;
  }
  return company || persona || "—";
};

export const formatRoom = (category?: string | null): string | null => {
  if (!category) return null;
  const upper = category.toUpperCase();
  if (upper === "CHARTERED") return "Chartered";
  if (upper === "UNCHARTERED") return "Unchartered";
  return humanizeEnumValue(category);
};
